// Progress state constants
export const PROGRESS_STATE = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2
};

// Progress key format constants
export const PROGRESS_KEY = {
  // Format: stepId
  STEP: (stepId) => stepId,
  // Format: stepId_option
  OPTION: (stepId) => `${stepId}_option`
}; 